import { Stack } from '@mui/material';
import { VyDivider } from '../../../../../../../../../components/new-design/atoms';
import type { GetExportedIntegrationsResponse, GetLightInvoicesResponse } from '@vy/api-definition';
import type { ItemOf } from '@vy/utils';
import { INTEGRATION_TYPES, SYNC_JOB_STATUSES } from '@vy/integrations-types';
import { XeroIntegrationStatusAccordion } from './invoice-activity-xero-sync-tab-components/XeroIntegrationStatusAccordion/XeroIntegrationStatusAccordion';
import { XeroInvoiceDetailsAccordion } from './invoice-activity-xero-sync-tab-components/XeroInvoiceDetailsAccordion/XeroInvoiceDetailsAccordion';
import { XeroInvoiceProductsAccordion } from './invoice-activity-xero-sync-tab-components/XeroInvoiceProductsAccordion/XeroInvoiceProductsAccordion';

type InvoiceActivityXeroSyncTabProps = {
  invoice: ItemOf<GetLightInvoicesResponse['invoices']>;
  exportedInvoiceIntegrations: GetExportedIntegrationsResponse;
};

export const InvoiceActivityXeroSyncTab: React.FC<InvoiceActivityXeroSyncTabProps> = ({
  invoice,
  exportedInvoiceIntegrations,
}) => {
  const xeroIntegration = findXeroIntegration(exportedInvoiceIntegrations);
  const isExported = xeroIntegration?.status === SYNC_JOB_STATUSES.COMPLETED;

  return (
    <Stack
      spacing="12px"
      sx={{
        height: 'calc(100vh - 400px)',
        overflowY: 'auto',
        scrollbarWidth: 'none',
      }}
      divider={<VyDivider />}
    >
      <XeroIntegrationStatusAccordion xeroIntegration={xeroIntegration} invoice={invoice} />
      <XeroInvoiceDetailsAccordion xeroIntegration={xeroIntegration} invoice={invoice} />
      <XeroInvoiceProductsAccordion invoiceId={invoice.id} isExported={isExported} />
    </Stack>
  );
};

function findXeroIntegration(exportedInvoiceIntegrations: GetExportedIntegrationsResponse) {
  return exportedInvoiceIntegrations.find(
    (exportedIntegration) => exportedIntegration.integration === INTEGRATION_TYPES.XERO,
  );
}
